<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      class="mb-4"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :field-name="getFieldName"
      :options="[
        { type: 'date', label: '조사일(필수)', value: '조사일' },
        { type: 'text', label: '공정내용' },
        { type: 'disaster', label: '재해형태(필수)', value: '재해형태' },
      ]"
    />

    <!-- 근골격계부담작업 -->
    <MusculoskeletalTensionExercisesTable v-model="form.table" :readonly="board.readonly" :is-print="isPrint" class="mt-28px" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import MusculoskeletalTensionExercisesTable from "@/views/boards/single-page/293/MusculoskeletalTensionExercisesTable";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    MusculoskeletalTensionExercisesTable,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object | undefined,
  },
  validations: {
    form: {
      stdInfo: {
        조사일: { required },
        재해형태: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        value.summary = {
          안전보건점검_사업장명: [],
          안전보건점검_점검표: []
        }

        value.summary['안전보건점검_사업장명'].push({
          [this.form.stdInfo.field_name]: 1
        })

        value.summary['안전보건점검_점검표'].push({
          ['[공통]근골격계부담작업 체크리스트']: 1
        })

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        table: [['', false, false, false, false, false, false, false, false, false, false, false]],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo["조사일"].required) {
          alert("조사일을 반드시 입력해야 합니다");
        } else if (!this.$v.form.stdInfo["재해형태"].required) {
          alert("재해형태를 반드시 입력해야 합니다");
        }

        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    getFieldName() {
      let fieldName = "사업장명";
      switch (parseInt(this.projectId)) {
      case 1: {
        fieldName = "시설물명";
        break;
      }
      case 2: {
        fieldName = "작업장명";
        break;
      }
      case 5: {
        fieldName = "시설물명";
        break;
      }
      }
      return `${fieldName}(필수)`;
    },
  },
};
</script>

<style scoped lang="scss"></style>
